export const MIN_AMOUNT = 10000;
export const MAX_AMOUNT = 10000000;
